import {
    Container,
    Grid,
    IconButton,
    InputAdornment,
    LinearProgress,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TextField,
    Tooltip,
    Hidden,
    Typography,
    Fab,
    makeStyles,
    Zoom,
    Badge,
    Chip,
    Button
} from "@material-ui/core";
import { green, orange, red, grey, purple, blueGrey } from "@material-ui/core/colors";
import {
    Add,
    Check,
    LocationOn,
    Search,
    Wifi,
    WifiOff,
    Error,
    Settings,
    NewReleases,
    Description,
    FlashOn,
    Warning,
    SyncProblem,
    Event,
    RemoveRedEye,
    InfoOutlined
} from "@material-ui/icons";
import { useHistory, useParams, useLocation } from "react-router-dom";
import React, { useContext, useEffect, useState } from "react";
import AddDevice from "../components/AddDevice";
import MapDialog from "../components/MapDialog";
import PageHeader from "../components/PageHeader";
import * as ROUTES from "../constants/routes";
import { useTranslation } from "react-i18next";
import DeviceSetupForm from "../components/DeviceSetupForm";
import { withAuthorization } from "../components/Session";
import * as DATANETAPI from "../components/DataNet/DataNet";
import DeviceStatusModal from "../components/DeviceStatusModal";
import { AuthUserContext } from "../components/Session";
import DeviceUseEventModal from "../components/DeviceUseEventModal";
import { set } from "lodash";
import ErrorDialog from "../components/ErrorDialog";
import moment from "moment";
import getDeviceStatus from "../functions/getDeviceStatus";
import Pads_Icon from "../assets/images/Parches_2.png";
import { Skeleton } from "@material-ui/lab";
import batteryRemainingCalc from "../functions/BatteryChargeCalc";
import SigfoxLogo from "../assets/images/sigfox-logo-vector.png";
import getDeviceComunications from "../functions/getDeviceComunications";
import { getDeviceDisplayName } from "../functions/getDeviceDisplayName";
import * as CONF from "../constants/conf";
import { ConsoleLogger } from "@microsoft/signalr/dist/esm/Utils";
import DirectionsBusIcon from "@material-ui/icons/DirectionsBus";
import WarningIcon from "@material-ui/icons/Warning";
import ErrorOutlineIcon from "@material-ui/icons/ErrorOutline";
import { hasAnyPermission, hasPermission } from "../functions/authorization";
import { DEVICE_ADD, DEVICE_UPDATE, GROUPS_UPDATE, EMT_VIEWER, EMT_ADMIN } from "../constants/roles";
import { deviceTrackingStyles } from "../components/DeviceTracking/DeviceTracking.styles";
import DeviceTrackingStatusIcon from "../components/DeviceTracking/DeviceTrackingStatusIcon";
import { hasOnlyInfoErrors, isInfoError } from "../functions/deviceStatusHelpers";
import TrackerBatteryIcon from "../components/DeviceTracking/TrackerBatteryIcon";
import DeviceFilters from "../components/DeviceFilters/DeviceFilters";
import { exportDevicesToCsv, exportDevicesToExcel } from "../components/DeviceFilters/DeviceExporter";

/* valores de periodos para dar mensaje de error de conexión */
const TRASNMISSION_FREC = {
    0: { gap: 3, type: "d" },
    1: { gap: 2, type: "w" },
    2: { gap: 1, type: "M" },
};

export const COMMUNICATION_STATUS = {
    NO_MODULE: 0,
    READY: 1,
    NOT_READY: 2
};

const DevicesPage = () => {
    const history = useHistory();
    const { programId, groupId } = useParams();
    const { t } = useTranslation();
    const classes = useStyles();
    const authUser = useContext(AuthUserContext);
    const canAddDevice = hasPermission(authUser, DEVICE_ADD);
    const canConfigureDevices = hasAnyPermission(authUser, [DEVICE_UPDATE, GROUPS_UPDATE]);
    const readOnly = !canConfigureDevices;

    const [isMapOpen, setisMapOpen] = useState(false);
    const [deviceLocation, setDeviceLocation] = useState({});
    const [devices, setDevices] = useState([]);
    const [areDevicesLoaded, setAreDevicesLoaded] = useState(false);
    const [isFiltered, setisFiltered] = useState(false);
    const [addNewOpen, setaddNewOpen] = useState(false);
    const [deviceSetupOpen, setdeviceSetupOpen] = useState(false);
    const [isNewVersion, setIsNewVersion] = useState(false);
    const [isStatusModalOpen, setisStatusModalOpen] = useState(false);
    const [deviceStatus, setDeviceStatus] = useState({});
    const [useEventModalOpen, setisUseEventModalOpen] = useState(false);
    const [deviceUseEvents, setDeviceUseEvents] = useState([]);
    const [usageNotifications, setUsageNotifications] = useState([]);
    const [areDeviceUseEventsLoaded, setAreDeviceUseEventsLoaded] = useState(false);
    const [filterValue, setFilterValue] = useState("");
    const [newInterval, setNewInterval] = useState(0);
    const [connectionErrorMsg, setConnectionErrorMsg] = useState("");
    const [isInitialLoadDone, setIsInitialLoadDone] = useState(false);
    const [totalRows, setTotalRows] = useState(0);
    const [deepLinkHandled, setDeepLinkHandled] = useState(false);
    const [autoOpenOperationalGis, setAutoOpenOperationalGis] = useState(false);
    const [hasEmtDevices, setHasEmtDevices] = useState(false);
    const [hasNormalDevices, setHasNormalDevices] = useState(false);
    const location = useLocation();
    const [filters, setFilters] = useState({
        deviceStatus: [],
        trackerStatus: [],
        trackerBattery: [],
        communicationStatus: []
    });
    const hasEmtViewRole = hasPermission(authUser, EMT_VIEWER);
    const hasEmtAdminRole = hasPermission(authUser, EMT_ADMIN);
    const [exportingCsv, setExportingCsv] = useState(false);
    const [exportingExcel, setExportingExcel] = useState(false);

    const [page, setPage] = useState(() => {
        const params = new URLSearchParams(location.search);
        return Number(params.get("page")) || 1;
    });
    useEffect(() => {
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    }, [page]);
    const totalPages = Math.ceil(totalRows / CONF.NUM_DEVICES_PER_PAGE);
    const getProgramType = (item) =>
        item?.program_type ??
        item?.programType ??
        item?.programtype;

    const isDeviceFromEmtProgram = (item) =>
        getProgramType(item)?.toString() === CONF.DEVICE_PROGRAM_TYPE_EMT?.toString();

    const isEmtProgram = devices.some((device) => isDeviceFromEmtProgram(device));

    const filterDevices = async (searchValue) => {
        setAreDevicesLoaded(false);
        try {
            const res = await DATANETAPI.searchDevices(page, CONF.NUM_DEVICES_PER_PAGE, searchValue);
            const items = res.data.items || [];
            const total = res.data.total || 0;

            setDevices(items);
            setTotalRows(total);
            setAreDevicesLoaded(true);
        } catch (err) {
            console.error(err);
        }
    };

    const handleSearch = (value) => {
        setPage(1);
        setFilterValue(value);
    };

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        params.set("page", page);
        history.replace({ search: params.toString() });

        const timeout = setTimeout(() => {
            if (filterValue?.trim()) {
                filterDevices(filterValue);
                setisFiltered(true);
            } else {
                setisFiltered(false);
                loadDevices();
            }
        }, 400);

        return () => clearTimeout(timeout);
    }, [page, filterValue, programId, groupId, filters]);

    useEffect(() => {
        if (filterValue?.trim()) {
            filterDevices(filterValue);
        } else {
            loadDevices();
        }
    }, [newInterval]);

    const displayMap = (location) => {
        setDeviceLocation(location);
        setisMapOpen(true);
    };

    const loadDevices = () => {
        setAreDevicesLoaded(false);
        devicesBack = devicesBack || [];
        if (!addNewOpen) {
            DATANETAPI.getDevices(programId, groupId, page, CONF.NUM_DEVICES_PER_PAGE, filters).then((snap) => {
                if (snap.status >= 0) {
                    if (snap.data !== undefined) {
                        const items = snap.data.items || snap.data || [];
                        const total = snap.data.total || items.length;
                        // Comprobar si hay algún dispositivo EMT
                        const hasEmt = snap.data.hasEmtDevices ?? false;
                        //hardcoded: habilita filtros.
                        setHasEmtDevices(hasEmt);
                        const hasNormal = snap.data.hasNormalDevices ?? false;
                        setHasNormalDevices(hasNormal);
                        devicesBack = items;
                        setDevices(items);
                        setTotalRows(total);

                        devicesBack.forEach((dev) => {
                            if (dev.status.main !== 2 && dev.model === CONF.DEVICE_MODEL_REANIBEX) {
                                let statusCount = 0;
                                Object.keys(dev.status.update).map((u) => {
                                    statusCount += dev.status.update[u];
                                });
                                if (statusCount > 0) {
                                    dev.status.main = 1;
                                }
                            }
                        });
                        setAreDevicesLoaded(true);
                        setIsInitialLoadDone(true);
                    } else {
                        setDevices([]);
                        setHasEmtDevices(false);
                        setAreDevicesLoaded(true);
                        setIsInitialLoadDone(true);
                    }
                } else {
                    setConnectionErrorMsg(t(`error.connection_${snap.status}`));
                    setDevices([]);
                    setHasEmtDevices(false);
                    setAreDevicesLoaded(true);
                    setIsInitialLoadDone(true);
                }
            });
        }
    };

    const getDevicesForExport = () => {
        return DATANETAPI.getDevices(
            programId,
            groupId,
            1,
            100000,
            filters
        ).then((snap) => {
            if (snap.status >= 0 && snap.data !== undefined) {
                return snap.data.items || snap.data || [];
            }

            return [];
        });
    };

    const handleExportCsv = () => {
        setExportingCsv(true);

        getDevicesForExport()
            .then((devices) => {
                devices.map((row, index) => {
                    const deviceStatus = getDeviceStatus(
                        row?.status,
                        moment().diff(row?.status?.updateDate, "months") >= (row?.connectivity ? 3 : 12),
                        batteryRemainingCalc({
                            software: row?.soft_version,
                            syncDate: moment(row?.status?.updateDate),
                            battery: row?.status?.device_status?.batteryStatus,
                            updateSource: row?.status?.device_status?.updateSource,
                        })
                    );

                    row.statusResult = deviceStatus.statusResult;
                    row.statusConnection = getCommunicationStatus(row, t);
                });

                exportDevicesToCsv(devices, hasEmtDevices, t, hasEmtAdminRole);
            })
            .finally(() => {
                setExportingCsv(false);
            });
    };

    const handleExportExcel = () => {
        setExportingExcel(true);

        getDevicesForExport()
            .then((devices) => {
                devices.map((row, index) => {
                    const deviceStatus = getDeviceStatus(
                        row?.status,
                        moment().diff(row?.status?.updateDate, "months") >= (row?.connectivity ? 3 : 12),
                        batteryRemainingCalc({
                            software: row?.soft_version,
                            syncDate: moment(row?.status?.updateDate),
                            battery: row?.status?.device_status?.batteryStatus,
                            updateSource: row?.status?.device_status?.updateSource,
                        })
                    );

                    row.statusResult = deviceStatus.statusResult;
                    row.statusConnection = getCommunicationStatus(row, t);
                });

                exportDevicesToExcel(devices, hasEmtDevices, t, hasEmtAdminRole);
            })
            .finally(() => {
                setExportingExcel(false);
            });
    };

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const deepLinkDeviceId = params.get("deviceId");
        const shouldOpenOperationalGis = params.get("openOperationalGis") === "1";

        if (deepLinkHandled || !deepLinkDeviceId || !shouldOpenOperationalGis) {
            return;
        }

        setDeepLinkHandled(true);

        DATANETAPI.getDevice(deepLinkDeviceId)
            .then((snap) => {
                if (snap?.status >= 0 && snap?.data) {
                    const device = snap.data.device || snap.data;

                    setAutoOpenOperationalGis(true);
                    setDeviceStatus(device);
                    setisStatusModalOpen(true);
                } else {
                    snap?.status < 0 && setConnectionErrorMsg(t(`error.connection_${snap.status}`));
                }
            })
            .catch((err) => {
                console.error(err);
            });
    }, [location.search, deepLinkHandled, t]);

    const openDeviceUseEvents = async (
        device,
        activeNotifications = []
    ) => {
        setDeviceStatus(device);
        setUsageNotifications(activeNotifications);
        setDeviceUseEvents([]);
        setAreDeviceUseEventsLoaded(false);
        setisUseEventModalOpen(true);

        try {
            const now = new Date();

            const dates = {
                start: new Date(
                    now.getFullYear() - 1,
                    now.getMonth(),
                    1
                ),
                end: now,
            };

            const snap =
                await DATANETAPI.getDeviceEvents(
                    device.id,
                    dates
                );

            if (snap?.status < 0) {
                setConnectionErrorMsg(
                    t(`error.connection_${snap.status}`)
                );
                return;
            }

            const events = Array.isArray(
                snap?.data?.events
            )
                ? snap.data.events
                : [];

            const patientUsageEvents = events.filter(
                (event) =>
                    Number(event?.event_type) === 6
            );

            setDeviceUseEvents(patientUsageEvents);
        } catch (error) {
            console.error(
                "Error obteniendo los eventos de uso:",
                error
            );

            setDeviceUseEvents([]);
        } finally {
            setAreDeviceUseEventsLoaded(true);
        }
    };

    useEffect(() => {
        let reaload = setInterval(() => {
            setNewInterval((prev) => !prev);
        }, 40 * 1000);

        return () => {
            clearTimeout(reaload);
        };
    }, []);

    useEffect(() => {
        devicesBack = [];
    }, [groupId, programId, addNewOpen]);

    useEffect(() => {
        DATANETAPI.newVersionGroup(groupId).then((snap) => {
            if (snap?.status < 0) {
                setConnectionErrorMsg(t(`error.connection_${snap.status}`));
                setIsNewVersion(false);
            } else {
                if (snap?.status === 1) {
                    setIsNewVersion(snap?.data?.is_available);
                } else {
                    setIsNewVersion(false);
                }
            }
        });
    }, [deviceSetupOpen, programId, groupId]);

    const handleTrackingStatusUpdated = (deviceId, trackerStatus, operationalIncidentStatus) => {
        const applyTrackingStatusUpdate = (device) => ({
            ...device,
            ...(trackerStatus !== undefined && { tracker_status: trackerStatus }),
            ...(operationalIncidentStatus !== undefined && { operational_incident_status: operationalIncidentStatus })
        });

        setDevices(prev => prev.map(d => (
            d.id === deviceId
                ? applyTrackingStatusUpdate(d)
                : d
        )));

        setDeviceStatus(prev => (
            prev?.id === deviceId
                ? applyTrackingStatusUpdate(prev)
                : prev
        ));
    };

    return (
        <Container disableGutters>
            <Grid container spacing={2} direction="column">
                <Grid item>
                    <PageHeader title={t("common.devices")} />
                </Grid>
                <Grid item>
                    <Paper style={{ padding: 12 }}>
                        <Grid container direction="row" alignItems="center">
                            <Grid item container alignItems="center" xs={6} justify="flex-start">
                                <Grid item>
                                    <TextField
                                        label={t("common.search")}
                                        onChange={(e) => {
                                            handleSearch(e.target.value);
                                        }}
                                        margin="dense"
                                        placeholder={t("common.search")}
                                        InputProps={{
                                            startAdornment: (
                                                <InputAdornment position="start">
                                                    <Search />
                                                </InputAdornment>
                                            ),
                                        }}
                                        variant="outlined"
                                    />
                                </Grid>
                            </Grid>
                            <Grid item xs={6} container justify="flex-end">
                                {(devices.some((d) => d.model === CONF.DEVICE_MODEL_REANIBEX) || isNewVersion) && (
                                    <Grid item>
                                        <Tooltip
                                            placement="top"
                                            enterDelay={750}
                                            title={
                                                !canConfigureDevices ? (
                                                    <Typography variant="body1" style={{ fontSize: 12 }}>
                                                        {t("permissions.noPermission")}
                                                    </Typography>
                                                ) : !!!groupId ? (
                                                    <Typography variant="body1" style={{ fontSize: 12 }}>
                                                        {t("devices.toolbar.tooltip.settingsDisabled")}
                                                    </Typography>
                                                ) : (
                                                    <Typography variant="body1" style={{ fontSize: 12 }}>
                                                        {isNewVersion ? t("devices.setUp.info.update_opt") : t("devices.toolbar.tooltip.settingsEnabled")}
                                                    </Typography>
                                                )
                                            }
                                        >
                                            <span>
                                                <IconButton arial-label={t("devices.setUp.info")} disabled={!!!groupId || !canConfigureDevices} style={{ color: canConfigureDevices && isNewVersion ? orange[500] : undefined }} onClick={() => canConfigureDevices && setdeviceSetupOpen(true)}>
                                                    {isNewVersion ? <NewReleases /> : <Settings />}
                                                </IconButton>
                                            </span>
                                        </Tooltip>
                                        <DeviceSetupForm
                                            open={deviceSetupOpen}
                                            handleClose={setdeviceSetupOpen}
                                            groupId={groupId}
                                            readOnly={readOnly}
                                            isEmtProgram={isEmtProgram}
                                        />
                                    </Grid>
                                )}

                                <Grid item>
                                    <Tooltip
                                        placement="top"
                                        title={
                                            <Typography variant="body1" style={{ fontSize: 12 }}>
                                                {!canAddDevice ? t("permissions.noPermission") : t("devices.toolbar.tooltip.addDevice")}
                                            </Typography>
                                        }
                                    >
                                        <span>
                                            <IconButton aria-label="add" disabled={!canAddDevice} onClick={() => canAddDevice && setaddNewOpen(true)}>
                                                <Add />
                                            </IconButton>
                                        </span>
                                    </Tooltip>
                                    <AddDevice open={addNewOpen} handleClose={setaddNewOpen} authUser={authUser} />
                                </Grid>
                            </Grid>
                        </Grid>
                    </Paper>
                </Grid>

                {hasEmtDevices && !hasNormalDevices && !hasEmtViewRole && (
                <Grid item>
                    <DeviceFilters
                        filters={filters}
                        onChange={(newFilters) => {
                            setPage(1);
                            setFilters(newFilters);
                        }}
                        onExportCsv={handleExportCsv}
                        onExportExcel={handleExportExcel}
                        exportingCsv={exportingCsv}
                        exportingExcel={exportingExcel}
                        hasNormalDevices={hasNormalDevices}
                        hasEmtViewRole={hasEmtViewRole}
                        hasEmtAdminRole={hasEmtAdminRole}
                    /></Grid>
                )}

                <Typography
                    variant="body2"
                    color="textSecondary"
                    style={{ marginBottom: 8, marginTop: 8, marginLeft: 12 }}
                >
                    {t("devices.results", {
                        shown: devices.length,
                        total: totalRows
                    })}
                </Typography>
                <Grid item className={classes.table}>
                    <TableContainer component={Paper} variant="outlined">
                        {!areDevicesLoaded && <LinearProgress />}
                        <Table size="small">
                            <TableHead>
                                <TableRow>
                                    <TableCell align="center">{t("common.state")}</TableCell>
                                    <Hidden smDown>
                                        <TableCell>{t("common.name")}</TableCell>
                                    </Hidden>
                                    <TableCell align="center">{t("common.serialNumber")}</TableCell>

                                    <Hidden smDown>
                                        <TableCell align="center">{t("common.model")}</TableCell>
                                    </Hidden>
                                    <Hidden xsDown>
                                        <TableCell align="center">{t("common.software")}</TableCell>
                                    </Hidden>
                                    <Hidden smDown>
                                        <TableCell align="center">{t("common.usage")}</TableCell>
                                    </Hidden>
                                    <Hidden xsDown>
                                        <TableCell align="center">{t("common.location")}</TableCell>
                                    </Hidden>
                                    {hasEmtDevices && !hasNormalDevices && !hasEmtViewRole && !hasEmtAdminRole &&
                                    <Hidden xsDown>
                                        <TableCell align="center">{t("devices.tracker_battery")}</TableCell>
                                    </Hidden>
                                    }
                                    <Hidden xsDown>
                                        <TableCell align="center">{t("common.communications")}</TableCell>
                                    </Hidden>
                                    <Hidden xsDown>
                                        <TableCell align="center">{t("common.connected")}</TableCell>
                                    </Hidden>
                                    <TableCell align="center" style={{ width: 70, minWidth: 70 }}>{t("description")}</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {!areDevicesLoaded
                                    ? [0, 1, 2, 3, 4, 5, 6, 7, 8, 9].map((i) => <LoadingRows ind={i} />)
                                    : devices.map((row, index) => {

                                        const deviceStatus = getDeviceStatus(
                                            row?.status,
                                            moment().diff(row?.status?.updateDate, "months") >= (row?.connectivity ? 3 : 12),
                                            batteryRemainingCalc({
                                                software: row?.soft_version,
                                                syncDate: moment(row?.status?.updateDate),
                                                battery: row?.status?.device_status?.batteryStatus,
                                                updateSource: row?.status?.device_status?.updateSource,
                                            })
                                        );

                                        const isDeviceOk =
                                            deviceStatus.statusResult === 0 ||
                                            hasOnlyInfoErrors(deviceStatus);

                                        const shouldPaintRed = !isDeviceOk;

                                        return (
                                            <TableRow
                                                hover
                                                key={row.serial}
                                                style={{
                                                    background: row?.status?.is_demo
                                                        ? orange[50]
                                                        : row.model === CONF.DEVICE_MODEL_REANIBEX
                                                            ? (shouldPaintRed ? red[50] : undefined)
                                                            : (
                                                                moment(row?.expirationDatePads).isBefore(moment().add(90, "days")) ||
                                                                moment(row?.expirationDateBatt).isBefore(moment().add(90, "days"))
                                                            )
                                                                ? red[50]
                                                                : undefined,
                                                }}
                                            >
                                                <TableCell align="center">
                                                    {row.model === CONF.DEVICE_MODEL_REANIBEX ? (
                                                        <IconButton
                                                            onClick={() => {
                                                                setDeviceStatus(row);
                                                                setisStatusModalOpen(true);
                                                            }}
                                                        >
                                                            <StatusIcon
                                                                row={row}
                                                                battery={batteryRemainingCalc({
                                                                    software: row?.soft_version,
                                                                    syncDate: moment(row?.status?.updateDate),
                                                                    battery: row?.status?.device_status?.batteryStatus,
                                                                    updateSource: row?.status?.device_status?.updateSource,
                                                                })}
                                                                hasEmtViewRole={hasEmtViewRole}
                                                            />
                                                        </IconButton>
                                                    ) : (
                                                        <IconButton
                                                            onClick={() => {
                                                                setDeviceStatus(row);
                                                                setisStatusModalOpen(true);
                                                            }}
                                                        >
                                                            {moment(row?.expirationDatePads).isBefore(moment()) || moment(row?.expirationDateBatt).isBefore(moment()) ? (
                                                                <Error style={{ color: red[400] }} />
                                                            ) : moment(row?.expirationDatePads).isBefore(moment().add(90, "days")) || moment(row?.expirationDateBatt).isBefore(moment().add(90, "days")) ? (
                                                                <Warning style={{ color: orange[400] }} />
                                                            ) : (
                                                                <Check style={{ color: green[300] }} />
                                                            )}
                                                        </IconButton>
                                                    )}
                                                </TableCell>
                                                <Hidden smDown>
                                                    <TableCell component="th" scope="row" style={{ fontWeight: 500 }}>
                                                        {row?.status?.is_demo && (
                                                            <Typography variant="body1" style={{ fontWeight: 600, color: orange[500] }}>
                                                                DEMO
                                                            </Typography>
                                                        )}
                                                        {` ${getDeviceDisplayName(row)}`}
                                                    </TableCell>
                                                </Hidden>

                                                <TableCell align="center">{row.serial}</TableCell>

                                                <Hidden smDown>
                                                    <TableCell align="center">{row.model}</TableCell>
                                                </Hidden>

                                                <Hidden xsDown>
                                                    <TableCell align="center">
                                                        {!row.soft_version ? (
                                                            <Typography>-</Typography>
                                                        ) : (
                                                            <>
                                                                {!row.status ? (
                                                                    <Typography>-</Typography>
                                                                ) : !row.status.hasOwnProperty("update") ? (
                                                                    <>{row.soft_version}</>
                                                                ) : (
                                                                    <>
                                                                        {row?.status.update?.has_new_audio || row.status.update?.has_new_cfg || row?.status.update?.has_new_soft ? (
                                                                            <Tooltip title={t("common.pending_update")}>
                                                                                <IconButton
                                                                                    onClick={() => {
                                                                                        setDeviceStatus(row);
                                                                                        setisStatusModalOpen(true);
                                                                                    }}
                                                                                >
                                                                                    <SyncProblem style={{ color: orange[300] }} />
                                                                                    <Typography variant="body2" style={{ color: grey[900] }}>
                                                                                        &nbsp;{row.soft_version}&nbsp;
                                                                                    </Typography>
                                                                                </IconButton>
                                                                            </Tooltip>
                                                                        ) : (
                                                                            <>{row.soft_version}</>
                                                                        )}
                                                                    </>
                                                                )}
                                                            </>
                                                        )}
                                                    </TableCell>
                                                    <Hidden smDown>
                                                        <TableCell align="center">
                                                            {row.model === CONF.DEVICE_MODEL_REANIBEX && row.soft_version !== undefined && row.soft_version > "0206" ? (
                                                                <AuthUserContext.Consumer>
                                                                    {(authUser) => {
                                                                        const activeUsageNotifications =
                                                                            authUser?.active_notifications
                                                                                ?.notification?.filter(
                                                                                    (notification) =>
                                                                                        String(
                                                                                            notification
                                                                                                ?.device_info
                                                                                                ?.serial
                                                                                        ) === String(row?.serial) &&
                                                                                        Number(
                                                                                            notification?.type
                                                                                        ) === 1
                                                                                ) ?? [];

                                                                        const hasPendingUsage =
                                                                            activeUsageNotifications.length > 0;

                                                                        return (
                                                                            <IconButton
                                                                                style={{ padding: 0 }}
                                                                                onClick={() =>
                                                                                    openDeviceUseEvents(
                                                                                        row,
                                                                                        activeUsageNotifications
                                                                                    )
                                                                                }
                                                                            >
                                                                                {hasPendingUsage ? (
                                                                                    <Badge
                                                                                        color="error"
                                                                                        variant="dot"
                                                                                    >
                                                                                        <FlashOn />
                                                                                    </Badge>
                                                                                ) : (
                                                                                    <FlashOn />
                                                                                )}
                                                                            </IconButton>
                                                                        );
                                                                    }}
                                                                </AuthUserContext.Consumer>
                                                            ) : (
                                                                "-"
                                                            )}
                                                        </TableCell>
                                                    </Hidden>
                                                </Hidden>

                                                <Hidden xsDown>
                                                    <TableCell align="center">
                                                        <Grid container justify="center" alignItems="center">
                                                            {isDeviceFromEmtProgram(row) ? (
                                                                <DeviceTrackingStatusIcon
                                                                    device={row}
                                                                    trackerPosition={
                                                                        row?.tracker_position ??
                                                                        (row?.tracker_status === 2 ? row?.location : null)
                                                                    }
                                                                    trackerOperationalGis={row?.tracker_operational_gis}
                                                                    onRefresh={async ({ silent = false } = {}) => {
                                                                        if (!row?.id) {
                                                                            return null;
                                                                        }

                                                                        try {
                                                                            const snap = await DATANETAPI.getDevice(row.id);

                                                                            if (snap?.status < 0 || snap?.data === undefined) {
                                                                                return null;
                                                                            }

                                                                            return Array.isArray(snap.data)
                                                                                ? snap.data.find(d => d?.id === row.id) || snap.data[0]
                                                                                : snap.data.device || snap.data;
                                                                        } catch (e) {
                                                                            console.error(e);
                                                                            return null;
                                                                        }
                                                                    }}
                                                                    enableInlineOperationalMap
                                                                />
                                                            ) : (
                                                                <IconButton onClick={() => displayMap(row.location)}>
                                                                    <LocationOn />
                                                                </IconButton>
                                                            )}
                                                        </Grid>
                                                    </TableCell>
                                                </Hidden>
                                                {hasEmtDevices && !hasNormalDevices && !hasEmtViewRole && !hasEmtAdminRole && <Hidden xsDown>
                                                    {isDeviceFromEmtProgram(row) ? ( 
                                                        <TableCell align="center">
                                                            <TrackerBatteryIcon level={row.tracker_battery_level} trackerStatus={row?.tracker_status} />
                                                        </TableCell>
                                                    ) : (
                                                        <TableCell align="center"><span>—</span></TableCell>
                                                    )}
                                                </Hidden>
                                                }
                                                <Hidden xsDown>
                                                    <TableCell align="center">
                                                        {/*  <img src={SigfoxLogo} width={64} />*/}

                                                        {row.model === CONF.DEVICE_MODEL_REANIBEX ? (
                                                            getDeviceComunications(row.options).map((v, i) => <Chip label={v} key={i} variant="default" size="small" color="secondary" style={{ borderRadius: 9, marginRight: 6 }} />)
                                                        ) : row.unabiz_alert ? (
                                                            <>
                                                                <Tooltip title={<Typography variant="body2">{t("unabiz.standalone.desc")}</Typography>} placement="top">
                                                                    <Chip
                                                                        label={"Unabiz"}
                                                                        key={row.id}
                                                                        variant="outlined"
                                                                        icon={<InfoOutlined />}
                                                                        onClick={() => { }}
                                                                        size="small"
                                                                        color="secondary"
                                                                        style={{ borderRadius: 9, marginRight: 6 }}
                                                                    />
                                                                </Tooltip>
                                                            </>
                                                        ) : (
                                                            t("not_available")
                                                        )}
                                                    </TableCell>
                                                </Hidden>
                                                <Hidden xsDown>
                                                    <TableCell align="center">
                                                        <TransmissionCheckItem deviceData={row} hasEmtViewRole={hasEmtViewRole} hasEmtAdminRole={hasEmtAdminRole} />
                                                    </TableCell>
                                                </Hidden>

                                                <TableCell align="center" style={{ width: 70, minWidth: 70 }}>
                                                    <IconButton
                                                        onClick={() => {
                                                            history.push(ROUTES.DEVICE + "/" + row.id + location.search);
                                                            window.scrollTo(0, 0);
                                                        }}
                                                    >
                                                        <Description />
                                                    </IconButton>
                                                </TableCell>
                                            </TableRow>
                                        );
                                    })}
                            </TableBody>
                        </Table>
                        {devices.length === 0 && areDevicesLoaded && (
                            <Grid container justify="center" alignContent="center" style={{ height: 120 }}>
                                <Typography variant="h4" color="textSecondary">
                                    {t("devices.notFound")}
                                </Typography>
                            </Grid>
                        )}
                    </TableContainer>
                    {/* Pagination */}
                    <Grid
                        container
                        justify="center"
                        alignItems="center"
                        spacing={2}
                        style={{ marginTop: 16, marginBottom: 8 }}
                    >
                        <Grid item>
                            <Button
                                variant="contained"
                                color="primary"
                                disabled={page === 1 || !areDevicesLoaded}
                                onClick={() => {
                                    setAreDevicesLoaded(false);
                                    setPage(1);
                                }}
                            >
                                «
                            </Button>
                        </Grid>

                        <Grid item>
                            <Button
                                variant="contained"
                                color="primary"
                                disabled={page === 1 || !areDevicesLoaded}
                                onClick={() => {
                                    setAreDevicesLoaded(false);
                                    setPage((prev) => prev - 1);
                                }}
                            >
                                {t("devices.pagination.previous")}
                            </Button>
                        </Grid>

                        <Grid item>
                            <Typography variant="body1" style={{ fontWeight: 600 }}>
                                {page} / {totalPages || 1}
                            </Typography>
                        </Grid>

                        <Grid item>
                            <Button
                                variant="contained"
                                color="primary"
                                disabled={page >= totalPages || !areDevicesLoaded}
                                onClick={() => {
                                    setAreDevicesLoaded(false);
                                    setPage((prev) => prev + 1);
                                }}
                            >
                                {t("devices.pagination.next")}
                            </Button>
                        </Grid>

                        <Grid item>
                            <Button
                                variant="contained"
                                color="primary"
                                disabled={page >= totalPages || !areDevicesLoaded}
                                onClick={() => {
                                    setAreDevicesLoaded(false);
                                    setPage(totalPages);
                                }}
                            >
                                »
                            </Button>
                        </Grid>
                    </Grid>
                    {/* Pagination */}

                    <MapDialog isOpen={isMapOpen} setisMapOpen={setisMapOpen} location={deviceLocation} />
                    <DeviceStatusModal
                        isStatusModalOpen={isStatusModalOpen}
                        setisStatusModalOpen={setisStatusModalOpen}
                        device={deviceStatus}
                        onTrackingStatusUpdated={handleTrackingStatusUpdated}
                        refreshDevices={loadDevices}
                        authUser={authUser}
                        autoOpenOperationalGis={autoOpenOperationalGis}
                        onOperationalGisAutoOpened={() => setAutoOpenOperationalGis(false)}
                    />
                    <DeviceUseEventModal
                        isUseEventModalOpen={useEventModalOpen}
                        setisUseEventModalOpen={
                            setisUseEventModalOpen
                        }
                        currentNotifications={
                            usageNotifications
                        }
                        events={deviceUseEvents}
                        isEventsLoaded={
                            areDeviceUseEventsLoaded
                        }
                    />
                </Grid>
            </Grid>
            <ErrorDialog errorMsg={connectionErrorMsg} clearError={() => setConnectionErrorMsg("")} />
            <Zoom in={devices.length > 0 && devices.some((d) => d.model === CONF.DEVICE_MODEL_REANIBEX) && !!groupId} timeout={250} unmountOnExit>
                <Tooltip
                    title={
                        <Typography variant="body1" style={{ fontSize: 12 }}>
                            {!canConfigureDevices ? t("permissions.noPermission") : t("group.r100Conf.button")}
                        </Typography>
                    }
                >
                    <span className={classes.Fab}>
                        <Fab variant="extended" color="primary" disabled={!canConfigureDevices} onClick={() => canConfigureDevices && setdeviceSetupOpen(true)} style={{ borderRadius: 19, textTransform: "none" }}>
                            <Settings style={{ marginRight: 6 }} />
                            {t("group.r100Conf.button")}
                        </Fab>
                    </span>
                </Tooltip>
            </Zoom>
        </Container>
    );
};

const LoadingRows = ({ ind }) => (
    <TableRow hover key={ind}>
        <TableCell align="center">
            <Skeleton variant="circle" width={32} height={32} style={{ padding: 4 }} />
        </TableCell>
        <TableCell align="center">
            <Skeleton variant="text" />
        </TableCell>
        <Hidden smDown>
            <TableCell align="center">
                <Skeleton variant="text" />
            </TableCell>
        </Hidden>
        <Hidden smDown>
            <TableCell align="center">
                <Skeleton variant="text" />
            </TableCell>
        </Hidden>
        <Hidden xsDown>
            <TableCell align="center">
                <Skeleton variant="text" />
            </TableCell>
            <Hidden smDown>
                <TableCell align="center">
                    <Skeleton variant="circle" width={32} height={32} style={{ padding: 4 }} />
                </TableCell>
            </Hidden>
        </Hidden>
        <Hidden smDown>
            <TableCell align="center">
                <Skeleton variant="text" />
            </TableCell>
        </Hidden>
        <Hidden xsDown>
            <TableCell align="center">
                <Skeleton variant="circle" width={32} height={32} style={{ padding: 4 }} />
            </TableCell>
        </Hidden>
        <Hidden xsDown>
            <TableCell align="center">
                <Skeleton variant="circle" width={32} height={32} style={{ padding: 4 }} />
            </TableCell>
        </Hidden>
        <TableCell align="center">
            <Skeleton variant="circle" width={32} height={32} style={{ padding: 4 }} />
        </TableCell>
    </TableRow>
);

export const getCommunicationStatus = (deviceData, t) => {
    if (!deviceData?.connectivity) {
        return {
            status: COMMUNICATION_STATUS.NO_MODULE,
            statusText: t("connection.not_module")
        };
    }

    const transmission =
        TRASNMISSION_FREC[
            deviceData?.transmission_mode?.transmit_frequency ?? 0
        ];

    const deviceLastTransmission =
        deviceData?.status?.device_status?.updateDate;

    const deviceStatus = getDeviceStatus(
        deviceData.status,
        false,
        deviceData?.status?.device_status?.batteryStatus?.remaining_percentage
    );

    if (hasOnlyInfoErrors(deviceStatus)) {
        return {
            status: COMMUNICATION_STATUS.READY,
            statusText: t("connection.ready")
        };
    }

    const isTransmissionOk =
        !moment()
            .subtract(transmission.gap, transmission.type)
            .isAfter(moment(deviceLastTransmission));

    if (isTransmissionOk) {
        return {
            status: COMMUNICATION_STATUS.READY,
            statusText: t("connection.ready")
        };
    }

    return {
        status: COMMUNICATION_STATUS.NOT_READY,
        statusText: t(
            `connection.not_ready_${transmission.type}`,
            { gap: transmission.gap }
        )
    };
};

const TransmissionCheckItem = ({ deviceData, hasEmtViewRole, hasEmtAdminRole }) => {
    const { t } = useTranslation();
    if (!deviceData.connectivity) {
        return (
            <Tooltip title={t("connection.not_module")}>
                <WifiOff style={{ color: grey[300] }} />
            </Tooltip>
        );
    } else {
        const transmission = !!deviceData?.transmission_mode?.transmit_frequency ? TRASNMISSION_FREC[deviceData?.transmission_mode?.transmit_frequency] : TRASNMISSION_FREC[0];
        const deviceLasttransmission = deviceData?.status?.device_status?.updateDate;
        /* HARDCODED: Poner conectado a todos los dispositivos. */
        if(hasEmtViewRole || hasEmtAdminRole) {
            return (
                <Tooltip title={t("connection.ready")}>
                    <Wifi color="secondary" />
                </Tooltip>
            );
        }
        /* HARDCODED: Poner conectado a todos los dispositivos. */
        /* Hardcoded: Error Devices */
        const deviceStatus = getDeviceStatus(
            deviceData.status,
            false,
            deviceData?.status?.device_status?.batteryStatus?.remaining_percentage
        );
        if (hasOnlyInfoErrors(deviceStatus)) {
            return (
                <Tooltip title={t("connection.ready")}>
                    <Wifi color="secondary" />
                </Tooltip>
            );
        }
        /* Hardcoded: Error Devices */
        if (!moment().subtract(transmission?.gap, transmission?.type).isAfter(moment(deviceLasttransmission))) {
            return (
                <Tooltip title={t("connection.ready")}>
                    <Wifi color="secondary" />
                </Tooltip>
            );
        } else {
            return (
                <Tooltip title={t(`connection.not_ready_${transmission.type}`, { gap: transmission.gap })}>
                    <WifiOff style={{ color: red[300] }} />
                </Tooltip>
            );
        }
    }
};

const StatusIcon = ({ row, battery, hasEmtViewRole }) => {
    const { status, connectivity } = row;
    const outOfSync = moment().diff(status?.updateDate, "months") >= (connectivity ? 3 : 12);

    if (!!status) {
        const deviceStatus = getDeviceStatus(status, outOfSync, battery);
        const state = deviceStatus.statusResult;

        /* Hardcoded: Error Devices */
        if(hasEmtViewRole) {
            console.log("ENTRA1");
            if (hasOnlyInfoErrors(deviceStatus)) {
                return <Check style={{ color: green[400] }} />;
            }
        }
        /* Hardcoded: Error Devices */
        if (state === 0) return <Check style={{ color: green[400] }} />;
        else if (state === 1) return <Warning style={{ color: orange[400] }} />;
        else return <Error style={{ color: red[400] }} />;
    } else {
        return <Check style={{ color: green[400] }} />;
    }
};

const condition = (authUser) => !!authUser;

export default withAuthorization(condition)(DevicesPage);

const useStyles = makeStyles((theme) => ({
    Fab: {
        color: blueGrey[50],
        position: "fixed",
        bottom: theme.spacing(3),
        right: theme.spacing(3),
        borderRadius: 19,
        textTransform: "none",
    },
    table: {
        [theme.breakpoints.down("md")]: {
            marginBottom: theme.spacing(7),
        },
        [theme.breakpoints.up("md")]: {
            marginBottom: theme.spacing(3),
        },
    },
    ...deviceTrackingStyles,
}));

var devicesBack = [];
